var render = function render() {
  var _vm = this,
    _c = _vm._self._c;
  return _c('XYDialog', {
    attrs: {
      "title": _vm.title,
      "visible": _vm.visible,
      "center": _vm.titleCenter,
      "width": "375px"
    },
    on: {
      "closed": _vm.close
    },
    scopedSlots: _vm._u([{
      key: "footer",
      fn: function () {
        return [_vm.isDangerConfirmBtn ? _c('XYButtonV2', {
          staticClass: "confirm-btn",
          attrs: {
            "type": "danger"
          },
          on: {
            "click": _vm.confirm
          }
        }, [_vm._v("确认")]) : _vm._e(), _vm.cancelBtnText ? _c('XYButtonV2', {
          attrs: {
            "type": "info"
          },
          on: {
            "click": _vm.cancel
          }
        }, [_vm._v(_vm._s(_vm.cancelBtnText))]) : _vm._e(), _vm.isPrimaryConfirmBtn ? _c('XYButtonV2', {
          staticClass: "confirm-btn",
          attrs: {
            "type": "primary"
          },
          on: {
            "click": _vm.confirm
          }
        }, [_vm._v("确认")]) : _vm._e()];
      },
      proxy: true
    }])
  }, [_c('div', [_vm._v(_vm._s(_vm.message))])]);
};
var staticRenderFns = [];
export { render, staticRenderFns };